import type { AiBusinessCenterModule } from '../types'

export const fmsModule: AiBusinessCenterModule = {
  key: 'fms',
  label: '财务管理',
  desc: '账套管理 / 会计科目 / 凭证处理 / 账簿查询 / 财务报表 / 期末结账',
  path: '/fms',
  homePath: '/fms/home',
  icon: 'ep:money',
  color: '#10b981',
  aliases: ['FMS', '财务管理', '财务系统', '财务会计', '总账']
}
